import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

/* side padding for full-screen button space */
export const SCORM_SIDE_SPACING = 172;
export const FOOTER_HEIGHT = 36;

export const scormCardContainer = css`
  @media ${BREAKPOINT_QUERIES.Mobile} {
    padding: 0;
  }
`;

export const nodeContainerStyles = (width: number) => ({
  width: `${width}px`,
});

export const nodeContainerStylesMobile = () => ({
  width: '100%',
  minHeight: '27rem',
  marginLeft: '0px',
  marginRight: '0px',
});

export const nodeContainerWidth = (width: number, height?: number) => css`
  ${nodeContainerStyles(width)}
  height: ${height ?? 0}px;
  @media ${BREAKPOINT_QUERIES.Mobile} {
    ${nodeContainerStylesMobile()}
  }
`;

export const rndClassname = (fullScreen: boolean) => css`
  transform: ${fullScreen ? 'none !important' : `translate(-50%, 0) !important`};
  left: 50% !important;
  position: relative !important;
`;
